module.exports = __webpack_public_path__ + "static/media/horimeter.0db0fc07.svg";